/* 28.10 (audyt wizualny, Marta: „kontynuuj”): drobne poprawki zachowania stron. Wczytywany w snippets/meta-tags.liquid.
   Powrót: usuń linijkę z pk-drobne.js w meta-tags.liquid.
   1) Karta produktu z wyborem zestawu (np. sofa 140 cm): przy zestawie była cena „od” najtańszej tkaniny (527,99 zł, bouclé),
      a pod tytułem cena wybranej tkaniny (540,99 zł). Teraz przy zestawie stoi cena dla wybranej tkaniny i koloru,
      a „od” tylko wtedy, gdy dokładnego wariantu nie ma.
   2) Lista produktów: licznik „25 produktów” liczył kafle (produkt z kilkoma tkaninami ma kafel na każdą tkaninę),
      a porównanie pod listą liczyło produkty (21). Licznik pokazuje teraz liczbę produktów. */
(function () {
  function zl(g) {
    var s = (g / 100).toFixed(2).split('.'), z = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return z + ',' + s[1] + ' zł';
  }
  /* 1) ceny przy zestawach */
  var prod = null, ostatni = '';
  function wariant() {
    var id = new URLSearchParams(location.search).get('variant');
    var v = id && prod.variants.find(function (x) { return String(x.id) === id; });
    return v || prod.variants.find(function (x) { return x.available; }) || prod.variants[0];
  }
  function ceny() {
    if (!prod || prod.options.length < 2) return;
    var box = document.querySelector('.pkk__opt.pkk-first .pkk__vals'); if (!box) return;
    var v = wariant(), klucz = v.id + '|' + box.children.length; if (klucz === ostatni) return; ostatni = klucz;
    box.querySelectorAll('.pi').forEach(function (b) {
      var sm = b.querySelector('small'); if (!sm) return;
      var nazwa = b.textContent.replace(sm.textContent, '').trim();
      var dok = prod.variants.find(function (x) { return x.option1 === nazwa && x.option2 === v.option2 && x.option3 === v.option3; });
      var t;
      if (dok) t = zl(dok.price);
      else {
        var te = prod.variants.filter(function (x) { return x.option1 === nazwa && x.option2 === v.option2; });
        if (!te.length) return;
        t = 'od ' + zl(Math.min.apply(null, te.map(function (x) { return x.price; })));
      }
      if (sm.textContent !== t) sm.textContent = t;
    });
  }
  if (/\/products\//.test(location.pathname)) {
    fetch(location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      prod = p; ceny(); setInterval(ceny, 400);
    }).catch(function () {});
  }
  /* 2) licznik produktów na liście */
  function slowo(n) { var m10 = n % 10, m100 = n % 100; return n === 1 ? 'produkt' : (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) ? 'produkty' : 'produktów'; }
  function licznik() {
    var el = document.querySelector('[data-ile]'); if (!el) return;
    var m = el.textContent.match(/(\d+)\s+produkt/); if (!m) return;
    var kafle = [].slice.call(document.querySelectorAll('.pkg__grid > .pkg__c[data-h], .pkn__grid > .pkn__c[data-h]'));
    var widoczne = kafle.filter(function (c) { return c.offsetParent; }), ile = +m[1], zbior;
    /* licznik liczy wszystkie kafle albo widoczne (po filtrze); w obu wypadkach liczymy różne produkty z tego samego zbioru */
    if (ile === kafle.length) zbior = kafle; else if (ile === widoczne.length) zbior = widoczne; else return;
    var h = {}, n = 0;
    zbior.forEach(function (c) { if (!h[c.dataset.h]) { h[c.dataset.h] = 1; n++; } });
    if (!n || n === ile) return;
    var t = el.textContent, nowy = t.replace(/\d+\s+produkt(ów|y)?/, n + ' ' + slowo(n));
    if (nowy !== t) el.textContent = nowy;
  }
  if (/\/collections\//.test(location.pathname)) {
    var k = 0, ti = setInterval(function () { licznik(); if (++k > 20) clearInterval(ti); }, 400);
    document.addEventListener('click', function () { setTimeout(licznik, 150); setTimeout(licznik, 600); }, true);
  }
})();

/* 3) 28.10 (audyt, Marta: „dalej”): ikony liniowe zamiast emoji w pasku zaufania nad stopką i przy kontakcie w stopce;
      mega menu: zdjęcia paneli ładowane chwilę po wczytaniu strony, żeby nie było pustego prostokąta przy pierwszym najechaniu;
      poziome menu na telefonie: znacznik końca przewijania (zanikanie przy prawej krawędzi znika na końcu listy). */
(function () {
  var S = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
  var IK = {
    '🚚': S('<path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>'),
    '↩': S('<path d="M9 7 4 12l5 5"/><path d="M4 12h11a5 5 0 0 1 0 10h-2"/>'),
    '🇵🇱': S('<path d="M5 21V4"/><path d="M5 4h13v5H5"/><path d="M5 9h13v5H5"/>'),
    '✓': S('<path d="m5 12 4.5 4.5L19 7"/>'),
    '✉': S('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>'),
    '☎': S('<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/>')
  };
  function ikony() {
    document.querySelectorAll('.pkf__ic').forEach(function (e) { var t = e.textContent.trim(); if (IK[t]) e.innerHTML = IK[t]; });
    document.querySelectorAll('.pkf span[aria-hidden="true"]').forEach(function (e) { var t = e.textContent.trim(); if ((t === '✉' || t === '☎') && IK[t]) { e.className = 'pk-ik'; e.innerHTML = IK[t]; } });
  }
  function mega() { document.querySelectorAll('img[data-pkmm]:not([src])').forEach(function (i) { i.src = i.getAttribute('data-pkmm'); }); }
  function menuTel() {
    document.querySelectorAll('.menu-list__scroll-container').forEach(function (c) {
      if (c.__pk) return; c.__pk = 1;
      var f = function () { c.classList.toggle('pk-koniec', c.scrollLeft + c.clientWidth >= c.scrollWidth - 4); };
      c.addEventListener('scroll', f, { passive: true }); f();
    });
  }
  function start() { ikony(); menuTel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { start(); setTimeout(mega, 2500); });
})();

/* 28.10 (Marta: „każdy wariant powinien być oddzielnie na sklepie”, także wyszukiwarka):
   w wynikach wyszukiwania osobny kafel na każdy kolor produktu, który ma własne zdjęcie.
   Kolory produktu stoją zaraz za nim (najpierw neutralne, potem pastele); kolejność produktów jak w wynikach.
   Rozmiar, zestaw i piłeczki nie są rozbijane. Piłeczki i akcesoria zostają jednym kaflem. */
(function () {
  if (location.pathname.indexOf('/search') !== 0) return;
  function neutr(t) { t = (t || '').toLowerCase(); return /szar|grafit|beż|ecru|biał|biel|krem|cappuccino|piask|natural|kość|marmur/.test(t) ? 0 : /pastel|pudrow|jasno|mięt|liliow|lawend|błęk|morel|brzoskw/.test(t) ? 1 : 2; }
  function cena(gr, od) { var z = Math.floor(gr / 100), g = String(gr % 100); if (g.length < 2) g = '0' + g; return '<span class="price">' + (od ? 'od ' : '') + '<span class="pk-cena"><span class="pk-cena__z">' + z + '</span><span class="pk-cena__g">,' + g + '</span><span class="pk-cena__w">&nbsp;zł</span></span></span>'; }
  function src(u, w) { u = u.split('?')[0]; return u + '?width=' + w; }
  var LIM = 24;
  function strony(ul) {
    var lis = [].slice.call(ul.children).filter(function (x) { return x.classList.contains('product-grid__item'); });
    lis.forEach(function (x, i) { x.style.display = i >= LIM ? 'none' : ''; });
    var b = document.querySelector('.pkw-wiecej');
    if (!b) { b = document.createElement('button'); b.type = 'button'; b.className = 'pkw-wiecej'; ul.insertAdjacentElement('afterend', b); b.onclick = function () { LIM += 24; strony(ul); }; }
    var r = lis.length - LIM; b.hidden = r <= 0; b.textContent = 'Pokaż więcej (' + Math.max(r, 0) + ')';
  }
  async function wszystkie(ul) {
    /* wyniki ładują się stronami przy przewijaniu; dociągamy wszystkie strony od razu, żeby ułożyć kolory na całej liście */
    var last = +ul.dataset.lastPage || 1, sek = ul.closest('[id^="shopify-section-"]');
    if (last > 1 && sek) {
      var sid = sek.id.replace('shopify-section-', '');
      for (var n = 2; n <= last; n++) {
        try {
          var u = new URL(location.href); u.searchParams.set('page', n); u.searchParams.set('section_id', sid);
          var doc = new DOMParser().parseFromString(await (await fetch(u.toString())).text(), 'text/html');
          doc.querySelectorAll('ul.product-grid > .product-grid__item').forEach(function (li) {
            var id = li.getAttribute('data-product-id');
            if (id && ul.querySelector(':scope > .product-grid__item[data-product-id="' + id + '"]')) return;
            ul.appendChild(document.importNode(li, true));
          });
        } catch (e) {}
      }
    }
    ul.parentElement.querySelectorAll(':scope > span[ref="viewMoreNext"], :scope > span[ref="viewMorePrevious"]').forEach(function (x) { x.remove(); });
  }
  async function rozbij() {
    var ul = document.querySelector('ul.product-grid'); if (!ul || ul.__pkw) return;
    ul.__pkw = 1; LIM = 24;
    var stary = document.querySelector('.pkw-wiecej'); if (stary) stary.remove();
    await wszystkie(ul);
    var lis = [].slice.call(ul.querySelectorAll(':scope > .product-grid__item'));
    var dane = await Promise.all(lis.map(async function (li) {
      try {
        var a = li.querySelector('a.product-card__link'); if (!a) return null;
        var h = a.getAttribute('href').split('?')[0].split('/products/')[1]; if (!h) return null;
        var p = await (await fetch('/products/' + h + '.js')).json();
        return { li: li, p: p, h: h };
      } catch (e) { return null; }
    }));
    var reszty = [];
    dane.forEach(function (d) {
      if (!d) { reszty.push([]); return; }
      var p = d.p, ois = [];
      p.options.forEach(function (o, i) { var n = (o.name || o).toString().toLowerCase(); if (/kolor|materia|tkanin/.test(n) && !/pi[lł]ecz|kulk/.test(n)) ois.push(i); });
      var oi = ois.length ? ois[0] : -1;
      var typ = (p.type || '').toLowerCase();
      if (oi < 0 || /pi[lł]eczki/.test(d.h) || /akcesor|poduszk|pokrow/.test(typ)) { reszty.push([]); return; }
      var feat = (p.featured_image || '').split('?')[0].replace(/^https?:/, '');
      var grupy = {}, kol = [], uzyte = {}; uzyte[feat] = 1;
      p.variants.forEach(function (v) {
        var c = ois.map(function (j) { return v.options[j]; }).join(', '); if (!grupy[c]) { grupy[c] = { c: c, v: [], img: null, vid: null }; kol.push(c); }
        var g = grupy[c]; g.v.push(v);
        if (!g.img && v.featured_image && v.featured_image.src) { g.img = v.featured_image.src; g.vid = v.id; }
      });
      var featKol = null;
      kol.forEach(function (c) { var g = grupy[c]; if (g.img && g.img.split('?')[0].replace(/^https?:/, '') === feat) featKol = featKol || c; });
      var nowe = [];
      kol.forEach(function (c) {
        var g = grupy[c]; if (!g.img || c === featKol) return;
        var k = g.img.split('?')[0].replace(/^https?:/, ''); if (uzyte[k]) return; uzyte[k] = 1;
        nowe.push(g);
      });
      nowe.sort(function (a, b) { return neutr(a.c) - neutr(b.c); });
      if (featKol) dopisz(d.li, featKol);
      reszty.push(nowe.map(function (g) { return klon(d, g); }));
    });
    function dopisz(li, c) {
      var pr = li.querySelector('product-price'); if (!pr || li.querySelector('.pkw-kol')) return;
      var t = c.replace(/^tkanina tapicerska/i, 'dzianina bawełniana').replace(/^welur/i, 'velvet').replace(/velvet soft/i, 'Velvet Soft');
      var s = document.createElement('div'); s.className = 'pkw-kol'; s.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      pr.insertAdjacentElement('beforebegin', s);
    }
    function klon(d, g) {
      var li = d.li.cloneNode(true);
      li.removeAttribute('id'); li.setAttribute('data-pkw', g.vid); li.removeAttribute('ref');
      li.querySelectorAll('[id]').forEach(function (e) { e.id = e.id + '-w' + g.vid; });
      var url = '/products/' + d.h + '?variant=' + g.vid;
      li.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.setAttribute('href', url); });
      var sl = li.querySelectorAll('slideshow-slide');
      sl.forEach(function (x, i) { if (i) x.remove(); });
      li.querySelectorAll('slideshow-arrows, .slideshow-controls, [class*="slideshow-control"]').forEach(function (x) { x.remove(); });
      var im = li.querySelector('img.product-media__image');
      if (im) { im.src = src(g.img, 700); im.srcset = src(g.img, 400) + ' 400w, ' + src(g.img, 700) + ' 700w, ' + src(g.img, 1000) + ' 1000w'; im.loading = 'lazy'; }
      var ceny = g.v.map(function (v) { return v.price; }), mn = Math.min.apply(null, ceny), mx = Math.max.apply(null, ceny);
      var pc = li.querySelector('product-price [ref="priceContainer"]'); if (pc) pc.innerHTML = cena(mn, mx > mn);
      li.querySelectorAll('.pkw-kol').forEach(function (x) { x.remove(); });
      dopisz(li, g.c);
      var card = li.querySelector('product-card'); if (card) card.setAttribute('data-featured-media-url', src(g.img, 500));
      return li;
    }
    /* kolory produktu zaraz za nim (Marta 29.10: „powinny być obok siebie te same produkty w różnym kolorze”) */
    dane.forEach(function (d, i) { if (!d) return; var po = d.li; reszty[i].forEach(function (k) { po.insertAdjacentElement('afterend', k); po = k; }); });
    strony(ul);
  }
  var st = document.createElement('style');
  st.textContent = '.product-grid__item:has(.pkw-kol) .pkfx-det,.product-grid__item[data-pkw] fieldset.variant-option--swatches{display:none!important}.pkw-kol{padding:0 15px;font-size:13px;color:#55525A;margin-top:-4px}.pkw-wiecej{display:block;margin:28px auto 0;border:1.5px solid #242326;background:#fff;color:#242326;border-radius:999px;padding:12px 28px;font:inherit;font-weight:700;font-size:15px;cursor:pointer}.pkw-wiecej:hover{background:#242326;color:#fff}';
  document.head.appendChild(st);
  /* po zmianie filtra albo sortowania lista wyników jest podmieniana, więc sprawdzamy co sekundę, czy jest nowa */
  setInterval(rozbij, 1000);
})();
